import { APP_LOGIN_URL } from "configs/env";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  exitImpersonation,
  login,
  loginDone,
  loginWithCookie,
  logout,
  logoutDone,
  setLoggingOutFlag,
  startLogin,
} from "./authActions";
import * as authServices from "./authServices";
import { exitImpersonationSlice } from "./authSlice";

function* loginByTokenSaga(action: ReturnType<typeof login>) {
  try {
    yield put(startLogin());
    const { token, successCallback } = action.payload;
    const userResult = yield call(authServices.loginByToken, token);
    //console.log(`URL userResult is ${JSON.stringify(userResult)}`);
    yield put(loginDone({ ...userResult, isLoginOverride: true }));

    successCallback();
  } catch (error) {
    yield put(loginDone({ error }));
  }
}

function* loginWithCookieSaga(action: ReturnType<typeof login>) {
  try {
    const { token, successCallback, shouldResetUser = true } = action.payload;
    if (shouldResetUser) yield put(startLogin());
    const userResult = yield call(authServices.loginByToken, token);
    //console.log(`Cookie userResult is ${JSON.stringify(userResult)}`);
    yield put(loginDone({ ...userResult, isLoginOverride: true }));

    successCallback();
  } catch (error) {
    yield put(loginDone({ error }));
  }
}

function* logoutByTokenSaga(action: ReturnType<typeof login>) {
  try {
    yield put(setLoggingOutFlag(true));
    yield call(authServices.logout);
    yield put(logoutDone());
    window.location.href = APP_LOGIN_URL;
  } catch (error) {
    yield put(loginDone({ error }));
  }
}

function* exitImpersonationSaga(action: ReturnType<typeof exitImpersonation>) {
  try {
    const { successCallback } = action.payload;
    yield put(exitImpersonationSlice());
    successCallback();
  } catch (error) {
    console.log(error);
  }
}

function* watchLoginSaga() {
  yield takeLatest(login, loginByTokenSaga);
}

function* watchLoginWithCookieSaga() {
  yield takeLatest(loginWithCookie, loginWithCookieSaga);
}

function* watchLogoutSaga() {
  yield takeLatest(logout, logoutByTokenSaga);
}

function* watchExitImpersonationSaga() {
  yield takeLatest(exitImpersonation, exitImpersonationSaga);
}

export default function* () {
  yield all([
    watchLoginSaga(),
    watchLoginWithCookieSaga(),
    watchLogoutSaga(),
    watchExitImpersonationSaga(),
  ]);
}
